// Premium Header Scroll Logic — targets Dawn's .header-wrapper
document.addEventListener('DOMContentLoaded', () => {
  const headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;

  const handleScroll = () => {
    if (window.scrollY > 80) {
      headerWrapper.classList.add('header-scrolled');
    } else {
      headerWrapper.classList.remove('header-scrolled');
    }
  };

  // Set initial state
  handleScroll();
  window.addEventListener('scroll', handleScroll, { passive: true });
});
